import Reveal from "../lib/Reveal";

/** Ícone minimalista (seta do conector) */
function IconArrow() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.75">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

type Step = { title: string; desc: string };

const steps: Step[] = [
  { title: "Diagnóstico",     desc: "Levantamento técnico in loco e plano de adequações sem custo." },
  { title: "Projeto Óptico",  desc: "Desenho da rede para o prédio, com documentação e padrões." },
  { title: "Instalação",      desc: "Infra interna organizada (racks/patch) e teste de aderência." },
  { title: "Ativação",        desc: "Habilitação por unidade, sem obras no apartamento." },
  { title: "Operação",        desc: "Monitoramento 24/7, SLA e melhorias contínuas." },
];

export default function ProcessRail() {
  return (
    <section
      id="como"
      className="
        relative overflow-hidden
        py-16 md:py-20
        bg-background
      "
    >
      {/* BG igual ao About */}
      <div className="pointer-events-none absolute inset-0">
        <div
          className="absolute -left-24 top-0 h-[34rem] w-[34rem] rounded-full blur-3xl opacity-[.22]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,0,100,.55) 0%, rgba(255,0,100,0) 60%)" }}
        />
        <div
          className="absolute right-[-8rem] bottom-[-10rem] h-[42rem] w-[42rem] rounded-full blur-3xl opacity-[.18]"
          style={{ background: "radial-gradient(50% 50% at 50% 50%, rgba(255,77,145,.45) 0%, rgba(255,77,145,0) 60%)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4">
        <Reveal>
          <header className="max-w-3xl">
            <h2 className="text-2xl md:text-4xl font-extrabold">Como funciona</h2>
            <p className="text-white/80 mt-2">
              Um fluxo em 5 etapas — do projeto à operação — pensado para síndicos e administradoras.
            </p>
          </header>

          {/* Grid responsiva sem scroll horizontal */}
          <div className="mt-8">
            <ol
              className="
                relative grid gap-6 md:gap-7 overflow-visible
                grid-cols-1 sm:grid-cols-2 lg:grid-cols-5
              "
            >
              {/* Linha condutora (mantida) só em telas grandes */}
              <div className="pointer-events-none absolute left-0 right-0 top-[44px] h-px bg-gradient-to-r from-transparent via-white/15 to-transparent hidden lg:block" />

              {steps.map((s, i) => (
                <li key={i} className="relative p-1 overflow-visible">
                  <article
                    className="group relative h-full rounded-2xl bg-white/5 backdrop-blur-md ring-1 ring-white/10 transition-all duration-300
                               hover:ring-white/25 hover:-translate-y-0.5 focus-within:ring-white/25"
                    aria-label={`${i + 1}. ${s.title}`}
                  >
                    {/* Header do card */}
                    <div className="flex items-center justify-between px-5 pt-5">
                      <span
                        className="inline-flex h-8 min-w-8 items-center justify-center rounded-full text-sm font-bold text-white shadow-sm"
                        style={{ background: "linear-gradient(135deg,#FF0064,#ff4d91)" }}
                        aria-hidden
                      >
                        {i + 1}
                      </span>

                      {/* Conector: só mostra em lg+, some no último */}
                      {i < steps.length - 1 ? (
                        <span className="hidden lg:inline-flex text-white/50 group-hover:text-white/80 transition-colors">
                          <IconArrow />
                        </span>
                      ) : (
                        <span className="w-4" aria-hidden />
                      )}
                    </div>

                    {/* Conteúdo */}
                    <div className="px-5 pb-5">
                      <h3 className="mt-3 text-lg font-semibold">{s.title}</h3>
                      <p className="mt-1 text-sm text-white/75 leading-relaxed">{s.desc}</p>

                      <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-white/60">
                        {i === 0 && <span className="rounded-full bg-white/10 px-2 py-1">Sem custo</span>}
                        {i === 2 && <span className="rounded-full bg-white/10 px-2 py-1">Obra mínima</span>}
                        {i === 3 && <span className="rounded-full bg-white/10 px-2 py-1">Sem obras no apto</span>}
                        {i === 4 && <span className="rounded-full bg-white/10 px-2 py-1">SLA dedicado</span>}
                      </div>
                    </div>

                    {/* Glow mais aparente, sem cortar */}
                    <div
                      className="pointer-events-none absolute -inset-2 md:-inset-3 rounded-3xl opacity-0 blur-md md:blur-lg transition-opacity duration-300
                                 group-hover:opacity-100"
                      style={{ background: "radial-gradient(60% 60% at 50% 0%, rgba(255,77,145,0.30), rgba(0,0,0,0))" }}
                    />
                  </article>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
